import { ConfettiEffect } from "@/react/components/shared/ConfettiEffect";
import { SkeletonLoader } from "@/react/components/shared/uikit/SkeletonLoader";
import { useChecklist } from "@/react/hooks/useChecklist";
import { CheckListProgress } from "./CheckListProgress";
import { CheckListSections } from "./CheckListSections";
import { ChecklistCompleted } from "./ChecklistCompleted";

export interface CheckListProps {
  variant?: "default" | "compact";
}

export const CheckList = ({ variant = "default" }: CheckListProps) => {
  const { isLoading, isComplete } = useChecklist();

  if (variant === "compact") {
    if (isComplete) {
      return null;
    }

    if (isLoading) {
      return (
        <div className="bg-primary border-primary rounded-2xl border p-6">
          <SkeletonLoader variant="row" />
        </div>
      );
    }

    return (
      <div className="bg-primary border-primary rounded-2xl border">
        <CheckListProgress variant="compact" />
        <CheckListSections variant="compact" />
      </div>
    );
  }

  return (
    <div className="bg-primary border-primary rounded-2xl border">
      <ConfettiEffect isComplete={isComplete} />
      {isLoading ? (
        <SkeletonLoader variant="checklist" />
      ) : (
        <div>
          <CheckListProgress />
          {isComplete ? <ChecklistCompleted /> : <CheckListSections />}
        </div>
      )}
    </div>
  );
};
